import React, { useState } from 'react';
import TreeNode from './TreeNode';
import { getTreeDepth } from '../utils/redirectParser';
import './RedirectTree.css';

const RedirectTree = ({ treeData }) => {
  const [expandedNodes, setExpandedNodes] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState('');

  const toggleNode = (nodePath) => {
    const newExpanded = new Set(expandedNodes);
    if (newExpanded.has(nodePath)) {
      newExpanded.delete(nodePath);
    } else {
      newExpanded.add(nodePath);
    }
    setExpandedNodes(newExpanded);
  };

  const expandAll = () => {
    const allPaths = new Set();
    const addAllPaths = (nodes) => {
      nodes.forEach(node => {
        allPaths.add(node.path);
        if (node.children && node.children.length > 0) {
          addAllPaths(node.children);
        }
      });
    };
    addAllPaths(treeData);
    setExpandedNodes(allPaths);
  };

  const collapseAll = () => {
    setExpandedNodes(new Set());
  };

  const filterNodes = (nodes, term) => {
    if (!term) return nodes;
    
    return nodes.filter(node => {
      const matchesSearch = node.name.toLowerCase().includes(term.toLowerCase());
      const hasMatchingChildren = node.children && filterNodes(node.children, term).length > 0;
      return matchesSearch || hasMatchingChildren;
    }).map(node => ({
      ...node,
      children: filterNodes(node.children, term)
    }));
  };

  const filteredData = filterNodes(treeData || [], searchTerm);
  const treeDepth = getTreeDepth(treeData || []);
  const totalNodes = treeData ? treeData.length : 0;

  if (!treeData) {
    return <div className="tree-loading">Loading tree data...</div>;
  }

  return (
    <div className="redirect-tree">
      <div className="tree-controls">
        <div className="tree-stats">
          <span className="stat-item">
            <strong>Root Levels:</strong> {totalNodes}
          </span>
          <span className="stat-item">
            <strong>Max Depth:</strong> {treeDepth}
          </span>
        </div>
        
        <div className="tree-actions">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search paths..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
          
          <div className="expand-buttons">
            <button onClick={expandAll} className="expand-btn">
              Expand All
            </button>
            <button onClick={collapseAll} className="expand-btn">
              Collapse All
            </button>
          </div>
        </div>
      </div>

      <div className="tree-container">
        {filteredData.length === 0 ? (
          <div className="no-results">
            {searchTerm ? `No paths found matching "${searchTerm}"` : 'No redirect data available'}
          </div>
        ) : (
          <div className="tree-nodes">
            {filteredData.map((node) => (
              <TreeNode
                key={node.path}
                node={node}
                isExpanded={expandedNodes.has(node.path)}
                onToggle={toggleNode}
                level={0}
                searchTerm={searchTerm}
                expandedNodes={expandedNodes}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RedirectTree; 